import { call, put } from 'redux-saga/effects';
import DeleteFileActions from '../redux/DeleteFileRedux';
import { api } from './api';


export function* deletefilesagas(action: any): Generator<any, void, any> {
  const { leave_id, children_id, file_id } = action;
  const response = yield call(api.deleteFile, leave_id, children_id, file_id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(DeleteFileActions.deleteFileSuccess(response.data));
  } else {
    yield put(DeleteFileActions.deleteFileFailure());
  }
}